var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333496C3.32592 0.333496 0.333252 3.32616 0.333252 7.00016C0.333252 10.6742 3.32592 13.6668 6.99992 13.6668C10.6739 13.6668 13.6666 10.6742 13.6666 7.00016C13.6666 3.32616 10.6739 0.333496 6.99992 0.333496ZM6.99992 1.66683C9.95333 1.66683 12.3333 4.04675 12.3333 7.00016C12.3333 9.95358 9.95333 12.3335 6.99992 12.3335C4.0465 12.3335 1.66659 9.95358 1.66659 7.00016C1.66659 4.04675 4.0465 1.66683 6.99992 1.66683ZM6.99992 3.00016C5.52659 3.00016 4.33325 4.1935 4.33325 5.66683H5.66659C5.66659 4.9335 6.26659 4.3335 6.99992 4.3335C7.73325 4.3335 8.33325 4.9335 8.33325 5.66683C8.33325 7.00016 6.33325 7.24483 6.33325 9.00016H7.66659C7.66659 7.8995 9.66659 7.3335 9.66659 5.66683C9.66659 4.1935 8.47325 3.00016 6.99992 3.00016ZM6.33325 9.66683V11.0002H7.66659V9.66683H6.33325Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.112884423631b7f5eb0c0a7d62ff1fcc.svg";
export { ForwardRef as ReactComponent };